import { compose, applyMiddleware, combineReducers, createStore } from 'redux';
import thunk from 'redux-thunk';
import persistState from 'redux-localstorage';

import { initialState as localeInitialState } from './features/locale/redux/initial';
import { reducer as appReducer } from './features/app';
import { reducer as localeReducer, actions as localeActions } from './features/locale';
import { reducer as authReducer } from './features/Auth';
import { reducer as notifyReducer } from './features/notify';
import { reducer as transactionReduces } from './features/transaction';
import { reducer as users } from './features/users/redux';
import { actionFilter } from 'services/timer';
import { reducer as totalReducee } from './features/Total';
import { reducer as treeReducer } from './features/tree';
import { reducer as promotionsReducer } from './features/promotions';
import { reducer as paymentReducer } from './features/payment';
import { reducer as statisticReducer } from './features/statistic';
import { reducer as notificationReducer } from './features/notifications';
import { reducer as slotsHistoryReducer } from './features/slotsHistory/redux';
import { reducer as myStatistics } from './features/myStatistics/redux';
import { reducer as generalReport } from './features/generalReport/redux';

const persistedStateSlicer = () => state => ({
  userSettings: state.userSettings,
  auth: state.auth,
  locale: {
    lang: state.locale.lang,
  },
});

const persistedStateMerge = (initialState, persistedState) => {
  if (!persistedState) return initialState;

  return {
    ...initialState,
    ...persistedState,
    locale: {
      ...localeInitialState,
      lang: persistedState.locale?.lang || localeInitialState.lang,
    },
  };
};

function configureStore(extra) {
  const middlewares = [thunk.withExtraArgument(extra), actionFilter];

  const reducer = createReducer();

  const store = createStore(
    reducer,
    compose(
      applyMiddleware(...middlewares),
      persistState(undefined, {
        slicer: persistedStateSlicer,
        merge: persistedStateMerge,
      }),
      window.__REDUX_DEVTOOLS_EXTENSION__
        ? window.__REDUX_DEVTOOLS_EXTENSION__({ trace: true })
        : arg => arg,
    ),
  );

  const savedLang = store.getState().locale.lang;

  if (savedLang) {
    store.dispatch(localeActions.changeLang(savedLang));
  }

  return store;
}

function createReducer() {
  return combineReducers({
    app: appReducer,
    locale: localeReducer,
    auth: authReducer,
    notify: notifyReducer,
    users: users,
    total: totalReducee,
    transaction: transactionReduces,
    tree: treeReducer,
    promotions: promotionsReducer,
    payment: paymentReducer,
    statistic: statisticReducer,
    notifications: notificationReducer,
    slotsHistory: slotsHistoryReducer,
    myStatistics,
    generalReport,
  });
}

export { createReducer };
export default configureStore;
